import React from 'react';
import { Grid, Typography } from '@mui/material';

interface FinancialSummaryItemProps {
  quantity: number;
  type: string;
  detail?: string;
  displayDirection?: boolean;
  order?: { xs: number, lg: number };
  columns?: { xs: number, lg: number };
}

const FinancialSummaryItem = (props: FinancialSummaryItemProps) => {
  return (
    <Grid item xs={props.columns?.xs ?? 6} lg={props.columns?.lg ?? 12} sx={{ order: props.order }}>
      <Typography
        sx={{
          fontSize: '32px',
          color: 'text.primary'
        }}
      >
        {props.displayDirection && (props.quantity > 0 ? '+' : '') + props.quantity}
        {!props.displayDirection && props.quantity}
      </Typography>

      <Typography
        sx={{
          fontSize: '18px',
          color: 'text.primary',
          fontWeight: 500
        }}
      >
        {props.type}
      </Typography>

      <Typography
        sx={{
          fontSize: '16px',
          color: 'text.primary'
        }}
      >
        {props.detail}
      </Typography>
    </Grid>
  );
};

export default FinancialSummaryItem;
